import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/services/auth-guard-service'

import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component'
import { SalesRepGuard } from './auth/services/sales-rep-guard-service';

const routes: Routes = [
  {
    path: '',
    loadChildren: './home/home.module#HomeModule',
    canActivate: [AuthGuard, SalesRepGuard]
  },
  {
    path: 'catalog',
    loadChildren: './catalog/catalog.module#CatalogModule',
    canActivate: [AuthGuard, SalesRepGuard]
  },
  {
    path: 'favorites',
    loadChildren: './catalog/catalog.module#CatalogModule',
    canActivate: [AuthGuard, SalesRepGuard]
  },
  {
    path: 'search/:searchTerm',
    loadChildren: './catalog/catalog.module#CatalogModule',
    canActivate: [AuthGuard, SalesRepGuard]
  },
  {
    path: 'checkout',
    loadChildren: './checkout/checkout.module#CheckoutModule',
    canActivate: [AuthGuard, SalesRepGuard]
  },
  {
    path: 'orders',
    loadChildren: './orders/orders.module#RootOrdersModule',
    canActivate: [AuthGuard, SalesRepGuard]
  },
  {
    path: 'pages',
    loadChildren: './pages/pages.module#PagesModule',
    canActivate: [AuthGuard, SalesRepGuard]
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
